import axios from 'axios';

import { User } from '../types';
import { API_URL } from '../config/env';
import { transformUser } from './helpers';

export async function getUserProfile(userID: string): Promise<User> {
  const {
    data: { data: profile },
  } = await axios.get(`${API_URL}/users/${userID}`);

  const user = transformUser(profile);

  return user;
}

export async function getMe(): Promise<User> {
  const {
    data: { data: profile },
  } = await axios.get(`${API_URL}/auth/getMe`);

  const user = transformUser(profile);

  return user;
}

export async function getUserFollower(): Promise<number[]> {
  const {
    data: { data: profile },
  } = await axios.get(`${API_URL}/get_followers`);
  let users: number[] = profile

  return users;
}

export async function followUser(userId: number) {
  const {
    data: { data },
  } = await axios.post(`${API_URL}/profile/followers/${userId}`, {});

  
  return data;
}

export async function getToasts() {
  const {
    data: { data },
  } = await axios.get(`${API_URL}/toasts?status=Active`);

  return data;
}

export async function unfollowUser(userId: number) {
  const {
    data: { data },
  } = await axios.delete(`${API_URL}/profile/followers/${userId}`);
  return data;
}
